<template>
    <v-dialog
            class="mask-view"
            v-model="show"
            persistent
            width="300"
    >
        <v-card>
            <v-card-text class="pt-2 pb-2">
                {{ text }}
                <v-progress-linear
                        indeterminate
                        color="grey"
                        class="mb-0"
                ></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>

export default {
    name: 'MaskView',
    props: {
        show: Boolean,
        text: {
            type: String,
            default: 'Bitte warten...',
        },
    },
};

</script>
<style scoped lang="scss"></style>
